export default {
    methods: {

        deepCopy(sourceItem) {
            let itemJSON = JSON.stringify(sourceItem)
            return JSON.parse(itemJSON)
        },

        deepCopyGridArray(sourceArr) {
            let newCopy = []
            for (let row=0; row < sourceArr.length; row++) {
                let rowArray = []
                for (let col=0; col < sourceArr[row].length; col++) {
                    let value = sourceArr[row][col]
                    rowArray.push(value)
                }
                newCopy.push(rowArray)
            }
            return newCopy
        },

        deepCopyColorsArray(sourceArr) {
            let newCopy = []
            for (let i=0; i < sourceArr.length; i++) {
                let value = sourceArr[i]
                let r = value.R
                let g = value.G
                let b = value.B
                let newColor = { R: r, G: g, B: b }
                newCopy.push(newColor)
            }
            return newCopy
        },

        // tieup, threading, treadling
        deepCopyNestedIntArray(srcArray) {
            let destArray = []
            for (let outerItemPosition = 0; outerItemPosition < srcArray.length; outerItemPosition++) {
                let innerItemsArray = []
                destArray.push(innerItemsArray)
                let sourceItemsArray = srcArray[outerItemPosition]
                for (let s=0; s < sourceItemsArray.length; s++) {
                    innerItemsArray.push(sourceItemsArray[s])
                }
            }
            return destArray
        },

        // warp threads, weft threads
        deepCopyThreadsArray(srcArray) {
            let destThreadsArray = []
            for (let t=0; t < srcArray.length; t++) {
                let threadColor = {}
                destThreadsArray.push(threadColor)
                threadColor.R = srcArray[t].R
                threadColor.G = srcArray[t].G
                threadColor.B = srcArray[t].B
            }
            return destThreadsArray
        }

    },

    data() {
        return {
        }
    }
}
